@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  width: 100%;
  background: var(--surface-default);
  cursor: pointer;

  &:hover {
    background-color: var(--surface-hover);
  }

  &.read {
    background: var(--background-soft);

    &:hover {
      background-color: var(--surface-hover);
    }
  }

  &.isDropdownOpen {
    background: var(--surface-hover);
  }
}

.contentWrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.headerRight {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dateSpan {
  color: var(--text-soft);
  text-align: right;
  @include typography-v2-body-xs;
}

.headerLeft {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-soft);
  @include typography-v2-body-xs;
}

.dot {
  width: 2px;
  height: 2px;
  border-radius: 9999px;
  background-color: var(--icon-soft);
}

.bodyWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.logoWrapper {
  position: relative;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.logoBadge {
  position: absolute;
  right: -4px;
  bottom: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 2px;
  @include border-radius-full;
  background-color: var(--background-soft);
}

.textContent {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.primaryText {
  @include typography-v2-ui-sm;
  color: var(--text-default);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.read {
    color: var(--text-soft);
  }

  &.isToastVariant {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
}

.secondaryText {
  @include typography-v2-body-sm;
  color: var(--text-default);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.read {
    color: var(--text-soft);
  }

  &.isToastVariant {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
}
